import { useCallback } from 'react';
import { supabase } from '../lib/supabase';

export function usePosts({ onUpdate } = {}) {
  const updatePostStatus = useCallback(async (postId, newStatus) => {
    const { error } = await supabase
      .from('agency_posts')
      .update({ status: newStatus })
      .eq('id', postId);
    if (error) throw error;
    if (onUpdate) await onUpdate();
  }, [onUpdate]);

  const createPosts = useCallback(async (clientId, posts) => {
    // Buscar o maior numero de post existente para o cliente
    const { data: existing } = await supabase
      .from('agency_posts')
      .select('number')
      .eq('client_id', clientId)
      .order('number', { ascending: false })
      .limit(1);

    let nextNumber = (existing?.[0]?.number || 0) + 1;

    const WEEKDAYS = ['Domingo', 'Segunda', 'Terca', 'Quarta', 'Quinta', 'Sexta', 'Sabado'];

    const rows = posts.map((post) => {
      const date = new Date(post.date + 'T12:00:00');
      const day = date.getDate();
      const month = date.getMonth() + 1;
      const weekday = WEEKDAYS[date.getDay()];
      const num = nextNumber++;

      return {
        id: `${clientId}-post-${num}`,
        number: num,
        client_id: clientId,
        weekday,
        day,
        month,
        date: post.date,
        title: post.title,
        working_title: post.title,
        format: post.format || 'Post',
        pillar: post.pillar || '',
        funnel_stage: post.funnel_stage || 'Topo de Funil',
        objective: '',
        spokesperson: post.spokesperson || '',
        content: post.content || '',
        status: 'aguardando_cliente',
        with_face: false,
      };
    });

    const { data, error } = await supabase
      .from('agency_posts')
      .insert(rows)
      .select();

    if (error) throw error;
    if (onUpdate) await onUpdate();
    return data;
  }, [onUpdate]);

  const createPostsFromChat = useCallback(async (clientId, dates, messageContent) => {
    // Separar o conteudo do agente por post (split em ## Post ou **Post)
    const extractPosts = (content) => {
      if (!content) return [];
      const lines = content.split('\n');
      const posts = [];
      let current = null;

      for (const line of lines) {
        const trimmed = line.trim();
        const isPostHeader = /^##\s*post\s*/i.test(trimmed) || /^\*\*post\s+\d/i.test(trimmed);

        if (isPostHeader) {
          if (current) posts.push(current);
          const title = trimmed.replace(/^##\s*/, '').replace(/\*\*/g, '');
          current = { title, content: line + '\n' };
        } else if (current) {
          current.content += line + '\n';
        }
      }
      if (current) posts.push(current);

      // Se nao achou separacao, tudo eh 1 post
      if (posts.length === 0) {
        const firstLine = lines.find(l => l.trim()) || 'Post';
        const title = firstLine.trim().replace(/^[#*]+\s*/, '').substring(0, 60);
        posts.push({ title, content });
      }

      return posts;
    };

    const extracted = extractPosts(messageContent);

    const posts = dates.map((date, i) => ({
      date,
      title: extracted[i]?.title || `Post ${i + 1}`,
      content: extracted[i]?.content || messageContent || '',
      format: 'Post',
      pillar: '',
      funnel_stage: 'Topo de Funil',
      spokesperson: '',
    }));

    return createPosts(clientId, posts);
  }, [createPosts]);

  return { updatePostStatus, createPosts, createPostsFromChat };
}
